export default __webpack_public_path__ + "static/media/gallery_02.00cc51c6.jpg";